import { render, staticRenderFns } from "./OrderSummaryDataComponent.vue?vue&type=template&id=2fac9a92&"
import script from "./OrderSummaryDataComponent.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports